import React, { useEffect } from "react";

// components
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,  
  Button
} from "reactstrap";
import MaterialTable from 'material-table';
import Header from "../../../components/Headers/Header.jsx";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET } from "../../../services/api_service.js";

// views
import JustificativaForm from '../../../views/admin/cadastros/JustificativaForm.jsx';

//Constants
import { table_translate, table_style } from "../../../constants/MaterialTable.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

export default function JustificativaList({history}) {    
  const [list_table, set_list_table] = React.useState([])
  const[list_loading, set_list_loading] = React.useState(false);
  
  const[showDetail, setshowDetail] = React.useState(false);
  const[itemDetail, setitemDetail] = React.useState(null);
  
  const GetList = () => {    
    set_list_loading(true);

    api_GET('justificativa').then(result => {
      set_list_loading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else{
        let list = [];
        result.data.map(m => {
          let item = m;
          item.descricaoTipo = handleNomenclaturaTipo(m);
          list.push(item);
        })
        set_list_table(list);
      }
    });
  }

  const Edit = (event, rowData) => {    
    setitemDetail(rowData);
    setshowDetail(true);    
  }

  const Add = () => {
    setitemDetail(null);
    setshowDetail(true);    
  };

  const handleReturn = (item) => {
    let list;
    if (item != null)
    {
      GetList();
    }
    
    setshowDetail(false);  
    setitemDetail(null);  
  }

  useEffect(() => {
    GetList();
  }, []);

  const handleNomenclaturaTipo = (rowData) => {
    let tipo = "";
    
    if (rowData.coletaParcial) tipo = "Execução Parcial";
    if (rowData.naoColeta) tipo = tipo + (tipo != "" ? "; " : "") + "Não Execução";
    if (rowData.inconformidade) tipo = tipo + (tipo != "" ? "; " : "") + "Inconformidade";
    if (rowData.suspensaoOS) tipo = tipo + (tipo != "" ? "; " : "")+ "Suspensão de OS";
    if (rowData.pausaOS) tipo = tipo + (tipo != "" ? "; " : "") + "Pausa de OS";
    if (rowData.registroOcorrencia) tipo = tipo + (tipo != "" ? "; " : "") + "Registro de Ocorrência";
    if (rowData.comprovanteDestinacaoNaoRegistrado) tipo = tipo + (tipo != "" ? "; " : "") + "Não registro de Comprovante de Destinação";;

    return tipo;
  }

  const columnsProp = [
    { title: 'Descrição', field: 'descricao' },
    { title: 'Modalidade de Serviço', field: 'modalidadeColeta.descricao'},
    { title: 'Tipo', field: 'descricaoTipo'},
    { title: 'Status', field: 'status' },    
  ]  

  return (
    <>
        <Header />
        <Container className="mt--9" fluid>

          {!showDetail &&
            <Row>
              <Container className="mt-1" fluid>
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <Row>
                        <Col md="6">
                          <strong> Justificativas</strong>
                        </Col>
                        <Col md="6" className="text-right">                              
                          <Button color="primary" type="submit" onClick={() => Add()}>
                            <FontAwesomeIcon icon={faPlus} />  Nova Justificativa
                          </Button>
                        </Col>
                      </Row>                          
                  </CardHeader>  
                  <CardBody>
                    <Row>
                      <Col md="12">
                        <MaterialTable
                            title="Lista de Justificativas"
                            columns={columnsProp}
                            data={list_table}
                            isLoading={list_loading}
                            options={{
                              filtering: true,
                              exportButton: true,
                              pageSize: 20,
                              pageSizeOptions : [20, 50, list_table.length]
                            }}
                            actions={[
                              {
                                icon: 'edit',
                                tooltip: 'Editar Registro',
                                onClick: (event, rowData) => Edit(event, rowData)
                              }
                            ]}
                            localization={{
                              header: {
                                actions: 'Ações'
                              },
                              body: {
                                emptyDataSourceMessage: 'Nenhum registro para exibir',
                                editRow: {
                                  deleteText : "Deseja excluir o registro?",
                                  cancelTooltip : "Cancelar",
                                  saveTooltip : "Salvar"
                                },
                                deleteTooltip : "Excluir",
                                editTooltip : "Editar"
                              },
                              toolbar: {
                                searchTooltip: 'Pesquisar',
                                searchPlaceholder: 'Pesquisar'
                              },
                              pagination: {
                                labelRowsSelect: 'linhas',
                                labelDisplayedRows: '{count} de {from}-{to}',
                                firstTooltip: 'Primeira página',
                                previousTooltip: 'Página anterior',
                                nextTooltip: 'Próxima página',
                                lastTooltip: 'Última página'
                              }
                            }}  
                          />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>                  
              </Container>
            </Row>
          }          
          
          {showDetail && 
            <JustificativaForm handleReturn={handleReturn} item={itemDetail}></JustificativaForm>
          }

        </Container>        

    </>
  );
}
